import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
export default {
  name: "coachTeamList",
  mixins: [loadMoreList, commonData],
  data: function data() {
    return {
      paramsData: {
        name: ''
      },
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.getList();
  },
  destroyed: function destroyed() {
    sessionStorage.removeItem('teamId');
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.getTeamsList(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleMange: function handleMange(id) {
      sessionStorage.setItem('teamId', id + '');
      this.$router.push({
        path: "/coachmanage/teammanage",
        query: {
          teamId: id
        }
      });
    }
  }
};